import { truncateText } from "./truncateText.js";
const truncateTextBasedOnSize = ({
  text,
  size,
  breakpointLarge = 400,
  breakpointMax = 600,
  textSizeSmall = 220,
  textSizeLarge = 260,
  textSizeMax = 280
}) => {
  const isContainerLarge = size >= breakpointLarge;
  const isContainerMax = size >= breakpointMax;
  let textSize = textSizeSmall;
  if (isContainerLarge) textSize = textSizeLarge;
  if (isContainerMax) textSize = textSizeMax;
  return truncateText({ text, maxTextSize: textSize });
};
export {
  truncateTextBasedOnSize
};
//# sourceMappingURL=truncateTextBasedOnSize.js.map
